import css from 'styled-jsx/css'
import { colors, fontSizes, measurements } from 'theme'

export default css`
  .contact-page-wrapper {
    margin-left: auto;
    margin-right: auto;
    background: ${colors.lightBg};
    text-align: center;
  }

  .contact-page-wrapper .hero {
    min-height: 15rem;
    background-repeat: no-repeat;
    background-size: cover;
    background-position-x: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    text-align: center;
    padding: 5rem 0 4rem;
  }

  .contact-page-wrapper .hero .title {
    font-size: ${fontSizes.h1};
    margin-bottom: 0;
  }

  .contact-page-wrapper .hero img {
    width: 100%;
  }

  .contact-page-wrapper .sub-title {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }
  .contact-page-wrapper .schedule {
    font-size: ${fontSizes.h5};
    max-width: 50rem;
    margin: 0 auto 1.5rem auto;
  }

  .contact-page-wrapper p.message-welcome {
    font-size: ${fontSizes.h4};
    max-width: 50rem;
    margin: 0 auto;
  }

  .contact-page-wrapper :global(.form-container) {
    max-width: 33.75rem;
    margin: 0 auto;
    padding: 0.5rem;
  }

  .wrapper-icons {
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    max-width: 992px;
    margin: 0 auto;
  }
  .wrapper-icons.green {
    color: ${colors.primary};
  }
  .wrapper-icons.green :global(p) {
    color: ${colors.text};
  }

  .address {
    text-align: left;
    padding-left: 1rem;
  }

  .wrapper-map {
    height: 25rem;
    margin: 1rem auto;
  }

  .wrapper-response {
    width: 90%;
    margin: 0 auto;
    background: ${colors.white};
    padding: 1rem;
    border-radius: ${measurements.borderRadius};
  }

  .wrapper-response h3 {
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  @media screen and (max-width: 992px) {
    .contact-page-wrapper .hero {
      padding: 3rem 0 2rem;
    }
    .wrapper-icons {
      flex-direction: column;
    }
    .contact-page-wrapper .message-welcome {
      font-size: initial;
    }
  }
`

export const iconInfoStyle = css`
  .icon-info-wrapper {
    text-align: center;
    min-width: 18.5rem;
    max-width: 15rem;
    margin-left: auto;
    margin-right: auto;
  }
  .icon-info-wrapper .cicle-wrapper-icon {
    width: fit-content;
    margin: 0 auto;
    height: 5rem;
    width: 5rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.white};
    box-shadow: 0 11px 29px 0px ${colors.boxShadow};
  }
`
